import React, { useEffect, useState } from "react";
import api from "../lib/api";

/**
 * Logo del tenant (co-branding): affianca il marchio Wattline, mai lo
 * sostituisce. Senza logo → render null (fallback invisibile).
 * orgId opzionale: solo per super admin (vista org).
 */

const infoCache = new Map(); // key org|self -> Promise<info>
const blobCache = new Map(); // key `${org}@${version}` -> Promise<objectURL|null>

const orgQuery = (orgId) => (orgId ? `?org_id=${encodeURIComponent(orgId)}` : "");

const fetchInfo = (orgId) => {
  const key = orgId || "self";
  if (!infoCache.has(key)) {
    infoCache.set(key, api.get(`/org/branding${orgQuery(orgId)}`).then(({ data }) => data).catch(() => null));
  }
  return infoCache.get(key);
};

const fetchBlob = (orgId, version) => {
  const key = `${orgId || "self"}@${version}`;
  if (!blobCache.has(key)) {
    blobCache.set(
      key,
      api.get(`/org/branding/logo${orgQuery(orgId)}`, { responseType: "blob" })
        .then(({ data }) => URL.createObjectURL(data))
        .catch(() => null)
    );
  }
  return blobCache.get(key);
};

export const invalidateTenantLogo = (orgId) => {
  infoCache.delete(orgId || "self");
  for (const key of [...blobCache.keys()]) {
    if (key.startsWith(`${orgId || "self"}@`)) blobCache.delete(key);
  }
};

export const useTenantBranding = (orgId, refreshKey) => {
  const [info, setInfo] = useState(null);
  useEffect(() => {
    let alive = true;
    fetchInfo(orgId).then((d) => { if (alive) setInfo(d); });
    return () => { alive = false; };
  }, [orgId, refreshKey]);
  return info;
};

export const TenantLogo = ({ orgId, maxHeight = 28, maxWidth, className = "", testId, refreshKey }) => {
  const info = useTenantBranding(orgId, refreshKey);
  const [src, setSrc] = useState(null);

  useEffect(() => {
    if (!info?.has_logo) { setSrc(null); return undefined; }
    let alive = true;
    fetchBlob(orgId, info.logo_version).then((url) => { if (alive) setSrc(url); });
    return () => { alive = false; };
  }, [info, orgId]);

  if (!src) return null;
  return (
    <img
      src={src}
      alt="Logo aziendale"
      data-testid={testId}
      className={`object-contain shrink-0 ${className}`}
      style={{ maxHeight, maxWidth: maxWidth ?? maxHeight * 4 }}
    />
  );
};
